<template>
  <li class="location-radio-input">
    <input
      type="radio"
      v-model="location"
      :id="oneLocation.name"
      :value="oneLocation.branch_id"
    />
    <label :for="oneLocation.name">{{ oneLocation.name }}</label>
  </li>
</template>

<script>
export default {
  components: {},
  props: {
    oneLocation: {
      required: true,
      type: Object
    },
    value: {
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    location: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>
